var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Press.less');

require('dotdotdot');

module.exports = Section.extend({

    el: '.Press',

    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'resizeReleaseText');

        Section.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('fonts-loaded', this.resizeReleaseText);

        return Section.prototype.deactivate.call(this, params);
    },


    viewsRegistration: function () {
        Section.prototype.viewsRegistration.call(this);

        this.$('.Press-releasesItem-text').dotdotdot({
            watch: true
        });

        window.app.vent.on('fonts-loaded', this.resizeReleaseText);
    },


    resizeReleaseText: function () {
        this.$('.Press-releasesItem-text').trigger('update.dot');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Press/Press.js
// module id = 288
// module chunks = 0